import { Swiper as SwiperCore } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { DotIndicator } from '../components/Forms/DotIndicator';
import styles from './GettingStartedSwiper.module.css';

interface GettingStartedSwiperProps {
	Pages: { component: JSX.Element }[];
	handleClick: (index: number) => void;
	handleSlideChange: (swiper: SwiperCore) => void;
	setSwiperInstance: React.Dispatch<React.SetStateAction<SwiperCore | null>>;
	currentImageIndex: number;
}

export const GettingStartedSwiper: React.FC<GettingStartedSwiperProps> = ({
	Pages,
	handleClick,
	handleSlideChange,
	setSwiperInstance,
	currentImageIndex
}) => (
	<>
		{Pages.length > 1 && (
			<div className={styles.slideTracker}>
				{Pages.map((image, index) => (
					<div key={index} onClick={() => handleClick(index)} className={styles.imageTrackerDot}>
						<DotIndicator on={currentImageIndex === index} />
					</div>
				))}
			</div>
		)}

		<Swiper spaceBetween={10} slidesPerView={1} onSlideChange={handleSlideChange} onSwiper={setSwiperInstance}>
			{Pages.slice(0, 6).map((page, index) => (
				<SwiperSlide key={index}>{page.component}</SwiperSlide>
			))}
		</Swiper>
	</>
);
